
  import { defineComponent, onMounted, ref } from 'vue';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { useRoute } from 'vue-router';
  import { Actions } from '@/store/enums/StoreEnums';
  import { FinanceFundsRequestObject } from '@/store/modules/FinanceRequests/FinanceFundsRequestModule';
  import { useAbility } from '@casl/vue';

  export default defineComponent({
    name: 'finance-funds-request-overview',
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const route = useRoute();
      const { can } = useAbility();

      onMounted(() => {
        setCurrentPageBreadcrumbs(translate('financeFundsRequestOverview'), [
          translate('financesFunds'),
        ]);
      });

      const { data } = await store.dispatch(
        Actions.GET_FINANCE_FUNDS_REQUEST,
        route.params.id
      );

      const financesFundsRequest = ref<FinanceFundsRequestObject>(data.data);
      const translate = (text: string) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        translate,
        financesFundsRequest,
        can,
      };
    },
  });
